import { VideoRequestStatus } from "@/api/VideoRequest";
const VideoRequestInProgressIcon = `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 25.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="video-request-in-progress-icon" data-cy="video-request-in-progress-icon">
	<style type="text/css">
	.video-request-in-progress-icon .st0{fill:#FFFFFF;}
	.video-request-in-progress-icon .st1{fill:#2EAD4A;}
	.video-request-in-progress-icon .st2{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
	.video-request-in-progress-icon .st3{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	</style>
	<circle class="st0" cx="30" cy="30" r="30"/>
	<g>
		<circle class="st1" cx="52" cy="8" r="8"/>
	</g>
	<g>
		<g>
			<g>
				<path class="st1" d="M30.7,20.8c-5.4,0-9.7,4.4-9.7,9.7s4.4,9.7,9.7,9.7s9.7-4.4,9.7-9.7S36,20.8,30.7,20.8z M30.7,37.1
				c-3.6,0-6.6-3-6.6-6.6s3-6.6,6.6-6.6s6.6,3,6.6,6.6S34.3,37.1,30.7,37.1z"/>
				<path class="st1" d="M45.9,16.1h-5.7c-0.2,0-0.3-0.1-0.4-0.3l-1.6-3.3c0,0,0,0,0,0c-0.6-1.2-1.8-2-3.2-2h-8.4
				c-1.4,0-2.6,0.8-3.2,2c0,0,0,0,0,0l-1.6,3.3c-0.1,0.2-0.2,0.3-0.4,0.3h-5.8c-2.6,0-4.7,2.1-4.7,4.7v21c0,2.6,2.1,4.7,4.7,4.7
				h30.5c2.6,0,4.7-2.1,4.7-4.7v-21C50.6,18.2,48.5,16.1,45.9,16.1z M47.4,41.8c0,0.9-0.7,1.6-1.6,1.6H15.4c-0.9,0-1.6-0.7-1.6-1.6
				v-21c0-0.9,0.7-1.6,1.6-1.6h5.8c1.4,0,2.6-0.8,3.2-2c0,0,0,0,0,0l1.6-3.3c0.1-0.2,0.2-0.3,0.4-0.3h8.4c0.2,0,0.3,0.1,0.4,0.3
				l1.6,3.3c0,0,0,0,0,0c0.6,1.2,1.8,2,3.2,2h5.7c0.9,0,1.6,0.7,1.6,1.6V41.8z"/>
				<rect x="41.2" y="22.4" class="st1" width="3.1" height="3.1"/>
			</g>
		</g>
	</g>
	<g>
		<ellipse transform="matrix(0.2299 -0.9732 0.9732 0.2299 32.3049 56.7737)" class="st2" cx="52" cy="8" rx="5.8" ry="5.8"/>
		<polyline class="st3" points="52,12 52,8 50,6 	"/>
	</g>
</svg>
`;

const VideoRequestCompleteIcon = `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 25.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="video-request-complete-icon" data-cy="video-request-complete-icon">
	<style type="text/css">
	.video-request-complete-icon .st0{fill:#FFFFFF;}
	.video-request-complete-icon .st1{fill:#2EAD4A;}
	</style>
	<circle class="st0" cx="30" cy="30" r="30"/>
	<g>
		<g>
			<g>
				<path class="st1" d="M30.7,20.8c-5.4,0-9.7,4.4-9.7,9.7s4.4,9.7,9.7,9.7s9.7-4.4,9.7-9.7S36,20.8,30.7,20.8z M30.7,37.1
				c-3.6,0-6.6-3-6.6-6.6s3-6.6,6.6-6.6s6.6,3,6.6,6.6S34.3,37.1,30.7,37.1z"/>
				<path class="st1" d="M45.9,16.1h-5.7c-0.2,0-0.3-0.1-0.4-0.3l-1.6-3.3l0,0c-0.6-1.2-1.8-2-3.2-2h-8.4c-1.4,0-2.6,0.8-3.2,2l0,0
				l-1.6,3.3c-0.1,0.2-0.2,0.3-0.4,0.3h-5.8c-2.6,0-4.7,2.1-4.7,4.7v21c0,2.6,2.1,4.7,4.7,4.7h30.5c2.6,0,4.7-2.1,4.7-4.7v-21
				C50.6,18.2,48.5,16.1,45.9,16.1z M47.4,41.8c0,0.9-0.7,1.6-1.6,1.6H15.4c-0.9,0-1.6-0.7-1.6-1.6v-21c0-0.9,0.7-1.6,1.6-1.6h5.8
				c1.4,0,2.6-0.8,3.2-2l0,0l1.6-3.3c0.1-0.2,0.2-0.3,0.4-0.3h8.4c0.2,0,0.3,0.1,0.4,0.3l1.6,3.3l0,0c0.6,1.2,1.8,2,3.2,2h5.7
				c0.9,0,1.6,0.7,1.6,1.6L47.4,41.8L47.4,41.8z"/>
				<rect x="41.2" y="22.4" class="st1" width="3.1" height="3.1"/>
			</g>
		</g>
	</g>
	<g>
		<circle class="st1" cx="52" cy="8" r="8"/>
	</g>
	<g>
		<path class="st0" d="M46.7,9l3.3,3.6c0.1,0.2,0.4,0.2,0.6,0l6.8-7.8c0.1-0.1,0.1-0.4,0-0.5l-1-1.1c-0.2-0.2-0.4-0.2-0.6,0l-5.4,6.9
		c-0.1,0.1-0.2,0.1-0.3,0l-1.8-2.5c-0.1-0.2-0.4-0.2-0.6,0l-0.9,0.9C46.6,8.7,46.6,8.9,46.7,9z"/>
	</g>
</svg>
`;

const VideoRequestFailedIcon = `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 25.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="video-request-failed-icon" data-cy="video-request-failed-icon">
	<style type="text/css">
	.video-request-failed-icon .st0{fill:#FFFFFF;}
	.video-request-failed-icon .st1{fill:#FFC629;}
	.video-request-failed-icon .st2{fill:#2EAD4A;}
	</style>
	<circle class="st0" cx="30" cy="30" r="30"/>
	<g>
		<circle class="st1" cx="52" cy="8" r="8"/>
	</g>
	<g>
		<path class="st0" d="M50.4,2.5h3.2V5L53,9.6h-2L50.4,5V2.5z M50.5,10.8h3v2.7h-3V10.8z"/>
	</g>
	<g>
		<g>
			<g>
				<path class="st2" d="M30.7,20.8c-5.4,0-9.7,4.4-9.7,9.7s4.4,9.7,9.7,9.7s9.7-4.4,9.7-9.7S36,20.8,30.7,20.8z M30.7,37.1
				c-3.6,0-6.6-3-6.6-6.6s3-6.6,6.6-6.6s6.6,3,6.6,6.6S34.3,37.1,30.7,37.1z"/>
				<path class="st2" d="M45.9,16.1h-5.7c-0.2,0-0.3-0.1-0.4-0.3l-1.6-3.3l0,0c-0.6-1.2-1.8-2-3.2-2h-8.4c-1.4,0-2.6,0.8-3.2,2l0,0
				l-1.6,3.3c-0.1,0.2-0.2,0.3-0.4,0.3h-5.8c-2.6,0-4.7,2.1-4.7,4.7v21c0,2.6,2.1,4.7,4.7,4.7h30.5c2.6,0,4.7-2.1,4.7-4.7v-21
				C50.6,18.2,48.5,16.1,45.9,16.1z M47.4,41.8c0,0.9-0.7,1.6-1.6,1.6H15.4c-0.9,0-1.6-0.7-1.6-1.6v-21c0-0.9,0.7-1.6,1.6-1.6h5.8
				c1.4,0,2.6-0.8,3.2-2l0,0l1.6-3.3c0.1-0.2,0.2-0.3,0.4-0.3h8.4c0.2,0,0.3,0.1,0.4,0.3l1.6,3.3l0,0c0.6,1.2,1.8,2,3.2,2h5.7
				c0.9,0,1.6,0.7,1.6,1.6L47.4,41.8L47.4,41.8z"/>
				<rect x="41.2" y="22.4" class="st2" width="3.1" height="3.1"/>
			</g>
		</g>
	</g>
</svg>
`;

export const videoRequestIcon = (status: VideoRequestStatus) => {
  switch (status) {
    case VideoRequestStatus.InProgress:
      return VideoRequestInProgressIcon;
    case VideoRequestStatus.Complete:
      return VideoRequestCompleteIcon;
    case VideoRequestStatus.Failed:
      return VideoRequestFailedIcon;
  }
};
